import { IFixedExchangeRates } from 'types/Company.types';

export interface IExchangeRateRow {
  id: string;
  fromCurrency: string;
  toCurrency: string;
  rate: string;
}

export const buildFixedExchangeRates = (
  rateRows: IExchangeRateRow[]
): IFixedExchangeRates => {
  const rates: IFixedExchangeRates = {};
  rateRows.forEach((row) => {
    if (row.fromCurrency && row.toCurrency && row.rate) {
      const key = `${row.fromCurrency}/${row.toCurrency}`;
      rates[key] = parseFloat(row.rate);
    }
  });
  return rates;
};

export const isFormValid = (rateRows: IExchangeRateRow[]): boolean => {
  if (rateRows.length === 0) return true;
  return rateRows.every(
    (row) =>
      row.fromCurrency &&
      row.toCurrency &&
      row.rate &&
      !isNaN(parseFloat(row.rate)) &&
      parseFloat(row.rate) > 0
  );
};

export const parseExistingRates = (
  fixedExchangeRates: IFixedExchangeRates | undefined
): IExchangeRateRow[] => {
  if (!fixedExchangeRates || Object.keys(fixedExchangeRates).length === 0) {
    return [];
  }

  return Object.entries(fixedExchangeRates).map(([key, value], index) => {
    const [fromCurrency, toCurrency] = key.split('/');
    return {
      id: `row-${index}`,
      fromCurrency,
      toCurrency,
      rate: String(value),
    };
  });
};

export const createEmptyRow = (toCurrency = ''): IExchangeRateRow => ({
  id: `row-${Date.now()}`,
  fromCurrency: '',
  toCurrency,
  rate: '',
});
